export default "__VITE_ASSET__B1TFZ7ww__"